import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { PiCalendar } from 'react-icons/pi'
import { motion } from 'framer-motion'

import Radio from '@components/common/Radio/Radio'
import Button from '@/components/common/Button/Button'
import MotionText from '@/components/common/Motion/MotionText'
import HeaderBack from '@/components/dashboard/Header/HeaderBack'

import { useDashboardStore } from '@/store/useDashboardStore'
import { usePageSetup } from '@/hooks/usePageSetup'

export const DashboardYearPage = () => {
  const { t } = useTranslation();
  usePageSetup(t('dashboard.yearPageTitle'))
  const financialYear = useDashboardStore((state) => state.financialYear)
  const setFinancialYear = useDashboardStore((state) => state.setFinancialYear)
  const navigate = useNavigate()

  const [selectedYear, setSelectedYear] = useState(financialYear)

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    setFinancialYear(selectedYear)
    navigate("/")
  }

  return (
    <form onSubmit={handleSubmit} className="h-full bg-white pb-8 flex flex-col">
      <HeaderBack />
      <div className="flex-1 flex flex-col px-5">
        <div className="space-y-4 pr-12">
          <MotionText
            as="h2"
            className="text-zinc-900 text-3xl font-bold leading-tight"
            delay={0.2}
          >
            {t('taxes.yearSelection.title')}
          </MotionText>
        </div>
        <motion.div className='flex flex-col mt-8 mb-24 gap-4'
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{
            delay: 0.1,
            duration: 0.2,
            ease: "easeOut"
          }}
        >
          {Array.from({ length: new Date().getFullYear() - 2020 + 1 }, (_, index) => {
            const year = new Date().getFullYear() - index

            return (
              <Radio
                key={year}
                icon={<PiCalendar className='h-6 w-6 text-zinc-900' />}
                name="accountingYear"
                value={year.toString()}
                label={year.toString()}
                className='pb-4 border-b border-zinc-200'
                required
                checked={selectedYear === year}
                onChange={() => setSelectedYear(year)}
              />
            )
          })}
        </motion.div>
      </div>
      <motion.div className="flex flex-row gap-4 p-5 absolute bottom-0 w-full"
        exit={{ opacity: 0 }}
        transition={{
          duration: 0.2,
          ease: "easeOut"
        }}
        whileTap={{ scale: 0.98 }}
      >
        <Button type="submit">
          <span>{t('common.save')}</span>
        </Button>
      </motion.div>
    </form>
  )
}

export default DashboardYearPage